import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';
import EventTypeBadge from '../../widgets/EventTypeBadge';
import ConfirmationDetailField from '../components/ConfirmationDetailField';
import CoverImagePreview from '../components/CoverImagePreview';
import CoverImageOptimizingBlock from '../components/CoverImageOptimizingBlock';
import AttendeeEligibilityBadge from '../../../shared/registration/AttendeeEligibilityBadge';
// import RequireJoinApprovalBadge from '../../../shared/registration/RequireJoinApprovalBadge';
import ConfirmationEventTopicsSection from '../components/ConfirmationEventTopicsSection';
// import ConfirmationMemberMatchingSection from '../components/ConfirmationMemberMatchingSection';
import { COVER_IMAGE_ACCEPT } from '../eventFormConstants';
import ConfirmationMenuSummary from '../components/ConfirmationMenuSummary';
import LocationMapPreview from '../components/LocationMapPreview';
import {
  formatConfirmationDate,
  formatTimeRangeDisplay,
  formatCapacity,
} from '../components/confirmationFormatters';
import { isOnlineEventFormat } from '../eventFormatConstants';
// import { getRefundPolicyLabel } from '../partnerEventSettings';

const ConfirmationStep = ({
  form,
  coverImageOptimizing = false,
  coverImageOptimizationError = '',
  onCoverImageSelected,
  onCancelCoverImageOptimization,
}) => {
  const isOnline = isOnlineEventFormat(form.eventFormat);
  const locationDisplay = isOnline
    ? form.onlineMeetingLink
    : [form.venueName, form.location].filter(Boolean).join(', ') || form.venueName || form.location;

  const showCoverProcessing = coverImageOptimizing || Boolean(coverImageOptimizationError);

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 3 }}>
        Event Details
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <ConfirmationDetailField variant="row" label="Event Title" value={form.title} />
          <ConfirmationDetailField variant="row" label="Event Type">
            {form.type ? <EventTypeBadge type={form.type} compact /> : '—'}
          </ConfirmationDetailField>
          <ConfirmationDetailField
            variant="row"
            label="Date"
            value={formatConfirmationDate(form.eventDate)}
          />
          <ConfirmationDetailField
            variant="row"
            label="Time"
            value={formatTimeRangeDisplay(form.startTime, form.endTime)}
          />
          <ConfirmationDetailField
            variant="row"
            label="Capacity"
            value={formatCapacity(form.totalSeats)}
          />
          {/* Enable Waitlist hidden until users can configure this in the form. */}
          {/* <ConfirmationDetailField variant="row" label="Enable Waitlist">
            <ConfirmationStatusBadge enabled={form.enableWaitlist} />
          </ConfirmationDetailField> */}
          {/* Invite-Only hidden until users can configure this in the form. */}
          {/* <ConfirmationDetailField
            variant="row"
            label="Invite-Only"
            value={form.inviteOnly ? 'Yes' : 'No'}
          /> */}
          <ConfirmationDetailField variant="row" label="Gender Access">
            <AttendeeEligibilityBadge value={form.attendeeEligibility} />
          </ConfirmationDetailField>
          {/* Approval Flow hidden until users can configure this in the form. */}
          {/* <ConfirmationDetailField variant="row" label="Approval Flow">
            <RequireJoinApprovalBadge required={form.requireJoinApproval} />
          </ConfirmationDetailField> */}
          {/* Refund Policy hidden until shown in the product UI. */}
          {/* <ConfirmationDetailField
            variant="row"
            label="Refund Policy"
            value={getRefundPolicyLabel(form.refundPolicy)}
          /> */}

          <ConfirmationEventTopicsSection topics={form.topics} />
          {/* Member Matching hidden until users can configure this in the form. */}
          {/* <ConfirmationMemberMatchingSection enabled={form.memberMatching} /> */}

          <Divider sx={{ my: 2.5 }} />

          <Typography variant="body2" sx={{ fontWeight: 700, mb: 2 }}>
            Set Menu
          </Typography>
          <ConfirmationMenuSummary menuSections={form.menuSections} />
        </Grid>

        <Grid item xs={12} md={6}>
          {showCoverProcessing ? (
            <ConfirmationDetailField label="Cover Image">
              <CoverImageOptimizingBlock
                compact
                error={coverImageOptimizationError}
                onCancel={onCancelCoverImageOptimization}
                onRetry={coverImageOptimizationError ? onCoverImageSelected : undefined}
                accept={COVER_IMAGE_ACCEPT}
              />
            </ConfirmationDetailField>
          ) : form.coverImagePreview ? (
            <ConfirmationDetailField label="Cover Image">
              <CoverImagePreview src={form.coverImagePreview} />
            </ConfirmationDetailField>
          ) : null}

          <ConfirmationDetailField
            label="Description"
            value={form.description}
            preserveLineBreaks
            scrollable
          />
          <ConfirmationDetailField label="Short Description" value={form.wingmanDescription} />

          <Box sx={{ mt: 1 }}>
            <ConfirmationDetailField
              label={isOnline ? 'Online meeting link' : 'Location'}
              value={locationDisplay || '—'}
            />
            {!isOnline && (form.venueName || form.location) ? (
              <LocationMapPreview compact latitude={form.latitude} longitude={form.longitude} />
            ) : null}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConfirmationStep;
